export const publicRoute = {
  home: "/",
};
